<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">{{ titulo }} Cámara</h1>
                <router-link exact :to="'/presupuesto/' + presup" class="display-1">Presupuesto Nº {{ presup }}</router-link>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <empresa-select v-model="d.empresa_id"></empresa-select>
            </v-flex>
            <v-flex>
                <ubicacion-select v-model="d.ubicacion"></ubicacion-select>
            </v-flex>
            <v-flex>
                <v-text-field v-model="d.plazo_entrega" label="Plazo de entrega en días" validate="required"></v-text-field>
<!--                <v-menu-->
<!--                        ref="menuFechaEntrega"-->
<!--                        :close-on-content-click="false"-->
<!--                        v-model="menuFechaEntrega"-->
<!--                        :nudge-right="40"-->
<!--                        :return-value.sync="d.fecha_entrega"-->
<!--                        lazy-->
<!--                        transition="scale-transition"-->
<!--                        offset-y-->
<!--                        full-width-->
<!--                        min-width="290px"-->
<!--                >-->
<!--                    <v-text-field-->
<!--                            slot="activator"-->
<!--                            v-model="d.fecha_entrega"-->
<!--                            label="Fecha de Entrega"-->
<!--                            prepend-icon="event"-->
<!--                            readonly-->
<!--                            persistent-hint-->
<!--                            clearable-->
<!--                            hint="Fecha negociada entre la empresa y el cliente"-->
<!--                            :error-messages="errores.collect('fecha_entrega')"-->
<!--                            v-validate="'required'"-->
<!--                            data-vv-name="fecha_entrega"-->
<!--                            required-->

<!--                    ></v-text-field>-->
<!--                    <v-date-picker v-model="d.fecha_entrega" scrollable locale="es-sp">-->
<!--                        <v-spacer></v-spacer>-->
<!--                        <v-btn flat color="error" @click="menuFechaEntrega = false">Cancelar</v-btn>-->
<!--                        <v-btn flat color="success" @click="$refs.menuFechaEntrega.save(d.fecha_entrega)">Confirmar</v-btn>-->
<!--                    </v-date-picker>-->
<!--                </v-menu>-->
            </v-flex>
            <v-flex>
                <v-checkbox label="¿Para stock?" v-model="d.stock"></v-checkbox>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <form data-vv-scope="form" @submit.prevent="guardar()">
                    <v-card>
                        <v-card-title>
                            <h3 class="headline mb-0">Datos de la Cámara</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm5 md5>
                                    <v-radio-group v-model="d.camara_tipo" @change="panelesLimpia" row>
                                        <v-radio label="Convencional" value="c"></v-radio>
                                        <v-radio label="No convencional" value="n"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm2>
                                    <v-select label="Tipo" :items="tipos" item-value="value" item-text="text" v-model="tipo"></v-select>
                                </v-flex>
                                <v-flex v-if="tipo === 'p'" xs12 sm2>
                                    <v-select label="Ubicación" :items="ubicaciones" item-value="value" item-text="text" v-model="ubicacion"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <item-select v-model="panel" :id.sync="d.camara_panel_id" :tipo="5"></item-select>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.largo" label="Largo" suffix="mts"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex v-if="tipo === 'c'" xs12 sm2>
                                    <v-text-field v-model="d.ancho" label="Ancho" suffix="mts"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.alto" label="Alto" suffix="mts"></v-text-field>
                                </v-flex>
                                <v-flex v-if="tipo === 'c'" xs12 sm2>
                                    <v-text-field v-model="mt3" label="Mts³" readonly></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-btn color="primary" @click.native="panelesAgregar()">Agregar</v-btn>
                                </v-flex>
                            </v-layout>
                            <v-data-table hide-actions :headers="headers" :items="d.paneles">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">{{ props.item.tipo | tipo }}</td>
                                    <td class="text-xs-center">
                                        <v-icon>{{ props.item.ubicacion | icono }}</v-icon>
                                        {{ props.item.ubicacion | ubicacion }}
                                    </td>
                                    <td class="text-xs-center">{{ props.item.item.descripcion }}</td>
                                    <td class="text-xs-right">{{ props.item.largo }}</td>
                                    <td class="text-xs-right">{{ props.item.alto }}</td>
                                    <td class="text-xs-center">
                                        <v-btn flat icon color="red" @click.native="panelesQuitar(props.index)">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dibujoModal" persistent max-width="600" scrollable>
                                <v-btn slot="activator" color="primary" dark>Adicionar Croquis</v-btn>
                                <v-card>
                                    <v-card-title class="headline">Dibujo</v-card-title>
                                    <v-card-text>
                                        <canvas ref="dibujo" width="500px" height="400px" class="dibujo elevation-3"></canvas>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn flat @click.native="sketch.clear()">limpiar</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green darken-1" flat @click="dibujoModal = false">Cancelar</v-btn>
                                        <v-btn color="green darken-1" flat @click="d.dibujo = sketch.toImage(); dibujoModal = false">Guardar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card-actions>
                    </v-card>
                    <br>
                    <v-card v-if="d.dibujo">
                        <v-card-title>
                            <h3 class="headline mb-0">Croquis</h3>
                        </v-card-title>
                        <v-card-media :src="d.dibujo" contain max-height="300px"></v-card-media>
                    </v-card>
                    <!--<canvas ref="canvas" style="width: 100%;height: 300px;touch-action: none;"></canvas>-->
                    <br>
                    <v-card>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm5>
                                    <h3>Temperatura</h3>
                                    <v-radio-group v-model="d.camara_temp" row>
                                        <v-radio label="Baja" value="b"></v-radio>
                                        <v-radio label="Media" value="m"></v-radio>
                                        <v-radio label="Alta" value="a"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex xs12 sm5>
                                    <h3>Adicionales</h3>
                                    <v-layout>
                                        <v-flex>
                                            <v-checkbox v-model="d.camara_iluminacion" label="Iluminación" hide-details></v-checkbox>
                                        </v-flex>
                                        <v-flex>
                                            <v-checkbox v-model="d.camara_sellador" label="Sellador" hide-details></v-checkbox>
                                        </v-flex>
                                        <v-flex>
                                            <v-checkbox v-model="d.camara_kit" label="Kit baja temperatura" hide-details></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center class="text-xs-center">
                                <v-flex xs12><h3>Perfileria Exterior</h3></v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-select label="Muro / Muro" :items="perfileria" item-value="value" item-text="text" v-model="d.perfileria.emm"></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-select label="Muro / Techo" :items="perfileria" item-value="value" item-text="text" v-model="d.perfileria.emt"></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-select label="Muro / Piso" :items="perfileria" item-value="value" item-text="text" v-model="d.perfileria.emp"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center class="text-xs-center">
                                <v-flex xs12><h3>Perfileria Interior</h3></v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-select label="Muro / Muro" :items="perfileria" item-value="value" item-text="text" v-model="d.perfileria.imm"></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-select label="Muro / Techo" :items="perfileria" item-value="value" item-text="text" v-model="d.perfileria.imt"></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-select label="Muro / Piso" :items="perfileria" item-value="value" item-text="text" v-model="d.perfileria.imp"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-textarea label="Observaciones" v-model="d.obs" counter="100"
                                                :error-messages="errores.collect('obs')"
                                                v-validate="'max:100'"
                                                data-vv-name="obs"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                    <br>
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex class="text-xs-center">
                                    <h3>Puertas vinculadas</h3>
                                    <v-progress-circular indeterminate color="primary" v-if="puertasLoading"></v-progress-circular>
                                    <v-list>
                                        <template v-for="p in puertas">
                                            <v-list-tile @click="">
                                                <v-list-tile-action>
                                                    <v-checkbox v-model="d.puertas" :value="p.ident"></v-checkbox>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{p.item_id}} | {{ p.descripcion }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>{{ p.obs }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </v-flex>
                                <v-flex class="text-xs-center">
                                    <h3>Equipos vinculados</h3>
                                    <v-progress-circular indeterminate color="primary" v-if="equiposLoading"></v-progress-circular>
                                    <v-list>
                                        <template v-for="e in equipos">
                                            <v-list-tile @click="">
                                                <v-list-tile-action>
                                                    <v-checkbox v-model="d.equipos" :value="e.ident"></v-checkbox>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{e.item_id}} | {{ e.descripcion }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>{{ e.obs }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                    <br>
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.pu"
                                                  label="Precio Unitario"
                                                  :suffix="moneda.signo"
                                                  :error-messages="errores.collect('pu')"
                                                  v-validate="'required'"
                                                  data-vv-name="pu"
                                                  required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.cant" label="Cantidad" min="1"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="subtotal"
                                                  label="Subtotal"
                                                  :suffix="moneda.signo"
                                                  :error-messages="errores.collect('subtotal')"
                                                  v-validate="'required'"
                                                  data-vv-name="subtotal"
                                                  required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" dark :to="'/presupuesto/' + presup">CANCELAR</v-btn>
                            <v-btn type="submit" color="green" dark :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                    <br>
                    <tabla-items tipo="cam" :presup="presup" :moneda="moneda.id" ref="tabla"></tabla-items>
                </form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import empresaSelect from '../../../components/EmpresaSelect';
    import ubicacionSelect from '../../../components/UbicacionSelect';
    import ItemSelect from '../../../components/ItemSelect';
    import mixinPresupItem from '../../../mixins/presupuestoItems';
    import mixinItems from '../../../mixins/items';
    import mixinPresupuesto from '../../../mixins/presupuesto';
    import tablaItems from '../../../components/TablaItems';
    import atrament from 'atrament'; // paint
    // import * as BABYLON from 'babylonjs';


    function getInitialData() {
        return {
            item_id: '',
            item_tipo_id: '2',
            camara_tipo: 'c',
            camara_panel_id: '',
            largo: '',
            ancho: '',
            alto: '',
            mt3: '',
            cant: 1,
            pu: 0,
            subtotal: 0,
            obs: '',
            presupuesto_id: '',
            camara_temp: '',
            camara_iluminacion: false,
            camara_sellador: false,
            camara_kit: false,
            perfileria: {
                emm: '',
                emt: '',
                emp: '',
                imm: '',
                imt: '',
                imp: '',
            },
            paneles: [],
            dibujo: '',
            empresa_id: '',
            ubicacion: '',
            stock: false,
            puertas: [],
            equipos: [],
            fecha_entrega: '',
            plazo_entrega: ''
        }
    }

    let perfileria = [
        {text: 'Acero inoxidable', value: 1},
        {text: 'Metálica', value: 2},
        {text: 'Plástica', value: 3},
        {text: 'Aluminio', value: 4},
    ];
    let ubicaciones = [
        {text: 'Muro', value: 'm', icono: 'fa-square'},
        {text: 'Techo', value: 't', icono: 'fa-caret-square-up'},
        {text: 'Muro Divisor', value: 'd', icono: 'fa-th-large'},
        {text: 'Muro Compartido', value: 'c', icono: 'fa-arrows-alt-h'},
    ];
    let tipos = [
        {text: 'Cámara', value: 'c'},
        {text: 'Panel', value: 'p'},
    ];
    export default {
        name: "add",
        $_veeValidate: {
            validator: 'new'
        },
        components: {ItemSelect, tablaItems, empresaSelect, ubicacionSelect},
        mixins: [mixinPresupItem, mixinItems, mixinPresupuesto],
        data() {
            return {
                menuFechaEntrega: false,
                dibujoModal: false,
                sketch: {},
                tipo: 'c',
                ubicacion: '',
                panel: {id: '', descripcion: '', codigo: ''},
                moneda: {signo: '', id: ''},
                loading: false,
                d: getInitialData(),
                headers: [
                    {text: 'Tipo', value: 'tipo', align: 'center'},
                    {text: 'Ubicación', value: 'ubicacion', align: 'center'},
                    {text: 'Panel', value: 'panel', align: 'center'},
                    {text: 'Largo', value: 'largo', align: 'center'},
                    {text: 'Alto', value: 'alto', align: 'center'},
                ],
                perfileria: perfileria,
                tipos: tipos,
                ubicaciones: ubicaciones,
                x: 0.44,
                y: 0.88,
                box: {},
                scene: {},
                fTxt: {},
                baTxt: {},
                boTxt: {},
                puertas: [],
                puertasLoading: false,
                equipos: [],
                equiposLoading: false,
            }
        },
        filters: {
            ubicacion: (val) => {
                let r = ubicaciones.find(x => {
                    return x.value === val
                });
                return r.text;
            },
            tipo: (val) => {
                let r = tipos.find(x => {
                    return x.value === val
                });
                return r.text;
            },
            icono: (val) => {
                let r = ubicaciones.find(x => {
                    return x.value === val
                });
                return r.icono;
            },
        },
        computed: {
            ...mapState({
                presup: state => state.route.params.presup,
                oper: state => state.route.params.oper,
                id: state => state.route.params.id,
            }),
            titulo() {
                return (this.oper === 'add') ? 'Agregar' : 'Editar';
            },
            mt3() {
                let r = this.d.alto * this.d.ancho * this.d.largo;
                this.d.mt3 = r;
                return new Intl.NumberFormat('es-AR').format(r);
            },
            subtotal() {
                let r = this.d.pu * this.d.cant;
                this.d.subtotal = r;
                return new Intl.NumberFormat('es-AR').format(r);
            },
            total() {
                if (!this.items) {
                    return 0
                }
                return this.items.reduce((a, b) => {
                    return a + b.subtotal
                }, 0)
            }
        },
        mounted() {
            this.traeMoneda();
            this.traeDatos();
            this.sketch = atrament(this.$refs.dibujo);
            // this.grafico();
            this.d.presupuesto_id = this.$store.state.route.params.presup;
        },
        watch: {
            '$route': 'traeDatos',
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            muestraDibujo() {
                let context = this.$refs.dibujo.getContext('2d');
                let imageObj = new Image();
                imageObj.onload = function () {
                    context.drawImage(this, 0, 0);
                };
                imageObj.src = this.d.dibujo;
            },
            grafico() {
                let canvas = this.$refs.canvas;
                let engine = new BABYLON.Engine(canvas, true, {preserveDrawingBuffer: true, stencil: true});
                this.scene = new BABYLON.Scene(engine);
                this.scene.clearColor = new BABYLON.Color4(0, 0, 0, 0.0000000000000001);
                let camera = new BABYLON.ArcRotateCamera("Camera", 3 * Math.PI / 4, Math.PI / 4, 4, BABYLON.Vector3.Zero(), this.scene);
                camera.attachControl(canvas, true);
                // Add lights to the scene
                let light1 = new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(1, 1, 0), this.scene);
                let light2 = new BABYLON.PointLight("light2", new BABYLON.Vector3(0, 1, -1), this.scene);
                // Add and manipulate meshes in the scene
                let faceColors = new Array(6);
                faceColors[4] = new BABYLON.Color4(1, 0, 0, 1);   // red top
                faceColors[1] = new BABYLON.Color4(0, 1, 0, 1);   // green front
                let op = {height: 1, width: 1, depth: 1, updatable: true};
                this.box = BABYLON.MeshBuilder.CreateBox("box", op, this.scene);


                //Create dynamic texture
                // let textureGround = new BABYLON.DynamicTexture("dynamic texture", {width: 512, height: 256}, this.scene);
                // let f = new BABYLON.StandardMaterial("Mat", this.scene);
                // f.diffuseTexture = textureGround;
                // this.box.material = f;
                //Add text to dynamic texture
                // textureGround.drawText("Grass", 75, 135, "bold 44px monospace", "green", "white", true, true);

                let cantU = 2;
                let cantV = 1;
                // front
                let f = new BABYLON.StandardMaterial("material0", this.scene);
                this.fTxt = new BABYLON.DynamicTexture("ftxt", {width: 512, height: 256}, this.scene);
                this.fTxt.drawText("FRENTE", 75, 135, "bold 44px monospace", "red", "white", true, true);
                f.diffuseTexture = new BABYLON.Texture("img/terminacion/trapezoidal.png", this.scene);
                f.emissiveTexture = this.fTxt;
                f.diffuseTexture.uScale = 1;
                f.diffuseTexture.vScale = 1;
                // back
                let ba = new BABYLON.StandardMaterial("material1", this.scene);
                this.baTxt = new BABYLON.DynamicTexture("baTxt", {width: 512, height: 256}, this.scene);
                this.baTxt.drawText("ATRAS", 75, 135, "bold 44px monospace", "red", "white", true, true);
                ba.diffuseTexture = new BABYLON.Texture("img/terminacion/tableteado.png", this.scene);
                ba.emissiveTexture = this.baTxt;
                ba.diffuseTexture.uScale = cantU;
                ba.diffuseTexture.vScale = cantV;
                // left
                let l = new BABYLON.StandardMaterial("material2", this.scene);
                let lTxt = new BABYLON.DynamicTexture("lTxt", {width: 512, height: 256}, this.scene);
                lTxt.drawText("IZQUIERDA", 75, 135, "bold 44px monospace", "red", "white", true, true);
                l.diffuseTexture = new BABYLON.Texture("img/terminacion/colonial.png", this.scene);
                l.emissiveTexture = lTxt;
                l.diffuseTexture.uScale = cantU;
                l.diffuseTexture.vScale = cantV;
                // right
                let r = new BABYLON.StandardMaterial("material3", this.scene);
                let rTxt = new BABYLON.DynamicTexture("rTxt", {width: 512, height: 256}, this.scene);
                rTxt.drawText("DERECHA", 75, 135, "bold 44px monospace", "red", "white", true, true);
                r.diffuseTexture = new BABYLON.Texture("img/terminacion/microperforado.png", this.scene);
                r.emissiveTexture = rTxt;
                r.diffuseTexture.uScale = cantU;
                r.diffuseTexture.vScale = cantV;
                // top
                let t = new BABYLON.StandardMaterial("material4", this.scene);
                let tTxt = new BABYLON.DynamicTexture("tTxt", {width: 512, height: 256}, this.scene);
                tTxt.drawText("ARRIBA", 75, 135, "bold 44px monospace", "red", "white", true, true);
                t.diffuseTexture = new BABYLON.Texture("img/terminacion/francesa.png", this.scene);
                t.emissiveTexture = tTxt;
                t.diffuseTexture.uScale = cantU;
                t.diffuseTexture.vScale = cantV;
                // bottom
                let bo = new BABYLON.StandardMaterial("material5", this.scene);
                this.boTxt = new BABYLON.DynamicTexture("boTxt", {width: 512, height: 256}, this.scene);
                this.boTxt.drawText("ABAJO", 75, 135, "bold 44px monospace", "red", "white", true, true);
                bo.diffuseTexture = new BABYLON.Texture("img/terminacion/micronervado.png", this.scene);
                bo.emissiveTexture = this.boTxt;
                bo.diffuseTexture.uScale = cantU;
                bo.diffuseTexture.vScale = cantV;

                let multi = new BABYLON.MultiMaterial("muros", this.scene);
                multi.subMaterials.push(f);
                multi.subMaterials.push(ba);
                multi.subMaterials.push(l);
                multi.subMaterials.push(r);
                multi.subMaterials.push(t);
                multi.subMaterials.push(bo);
                //apply material
                this.box.subMeshes = [];
                let verticesCount = this.box.getTotalVertices();
                this.box.subMeshes.push(new BABYLON.SubMesh(0, 0, verticesCount, 0, 6, this.box));
                this.box.subMeshes.push(new BABYLON.SubMesh(1, 1, verticesCount, 6, 6, this.box));
                this.box.subMeshes.push(new BABYLON.SubMesh(2, 2, verticesCount, 12, 6, this.box));
                this.box.subMeshes.push(new BABYLON.SubMesh(3, 3, verticesCount, 18, 6, this.box));
                this.box.subMeshes.push(new BABYLON.SubMesh(4, 4, verticesCount, 24, 6, this.box));
                this.box.subMeshes.push(new BABYLON.SubMesh(5, 5, verticesCount, 30, 6, this.box));
                this.box.material = multi;

                engine.runRenderLoop(() => {
                    this.scene.render();
                });
            },
            graficoRefresh() {
                this.box.scaling.x = this.d.ancho / 5;
                this.box.scaling.y = this.d.alto / 5;
                this.box.scaling.z = this.d.largo / 5;
                this.boTxt.drawText("ABAJO:", 50, 50, "bold 44px monospace", "red", "white", true, true);
            },
            limpiar() {
                this.d = getInitialData();
                this.d.presupuesto_id = this.$store.state.route.params.presup;
                this.$validator.reset();
            },
            agregarCamaraConvencional() {
                if (!this.panel.id) {
                    this.msjShow({txt: 'Debe seleccionar un item por lo menos', tipo: 'error'})
                    return false;
                }
                this.d.paneles = [];
                for (let i = 0; i < 5; i++) {
                    let datos = {
                        tipo: this.tipo,
                        ubicacion: 'm',
                        largo: this.d.largo,
                        alto: this.d.alto,
                        item: this.panel,
                        item_id: this.panel.id
                    };

                    if (i === 4) {
                        datos.ubicacion = 't';
                        datos.alto = this.d.ancho;
                    } else if (i === 2 || i === 3) {
                        datos.largo = this.d.ancho;
                    }

                    this.d.paneles.push(datos)
                }
            },
            panelesAgregar() {
                if (this.d.camara_tipo === 'c' && this.tipo === 'c') {
                    this.agregarCamaraConvencional();
                    return
                }
                if (this.tipo === 'c') {
                    this.msjShow({txt: 'Para cámaras no convecionales debe elegir tipo panel', tipo: 'error'});
                    return;
                }
                let datos = {
                    tipo: this.tipo,
                    ubicacion: this.ubicacion,
                    largo: this.d.largo,
                    alto: this.d.alto,
                    item: this.panel,
                    item_id: this.panel.id
                };
                if (this.d.paneles.find(e => e.ubicacion === this.ubicacion) && this.d.camara_tipo === 'c') {
                    this.msjShow({txt: 'Elemento ya adicionado', tipo: 'error'});
                    return;
                }

                this.d.paneles.push(datos)
            },
            panelesLimpia() {
                this.d.paneles = [];
            },
            panelesQuitar(indx) {
                if (this.d.camara_tipo === 'c') {
                    this.panelesLimpia();
                } else {
                    this.d.paneles.splice(indx, 1)
                }
            },
            traePlazo() {
                this.presupuestoPlazo({presupuesto_id: this.d.presupuesto_id}, r => {
                    this.d.plazo_entrega = r;
                },err=>{
                    this.msjShow({txt: 'Error al obtener plazo', tipo: 'error'});
                })
            },
            traeDatos() {
                if (this.oper !== 'edit') {
                    this.traePlazo();
                    return false;
                }
                this.loading = true;
                this.presupuestoItemShow(this.id, r => {
                    this.d = r;
                    this.d.puertas = this.d.puertas.map(r => r.id);
                    this.d.equipos = this.d.equipos.map(r => r.id);
                    this.d.perfileria = (this.d.perfileria) ? this.d.perfileria : getInitialData().perfileria;
                    this.item = r.item;
                    // this.graficoRefresh();
                    this.muestraDibujo();
                    this.loading = false;
                    this.puertasGet();
                    this.equiposGet();
                }, err => {
                    console.log(err);
                    this.loading = false;
                });

            },
            traeMoneda() {
                this.presupuestoMoneda({presupuesto_id: this.presup}, r => {
                    this.moneda = r;
                }, err => {
                    console.log(err)
                })
            },
            guardar() {
                if (!this.d.presupuesto_id) {
                    this.msjShow({txt: 'Falta numero de presupuesto', tipo: 'error'});
                    return false;
                }
                this.$validator.validateAll('form')
                    .then(r => {
                        if (!r) {
                            return false;
                        }
                        this.loading = true;
                        if (this.oper === 'edit') {
                            this.presupuestoItemUpdate(this.d, r => {
                                this.msj = r;
                                this.limpiar();
                                this.loading = false;
                                this.$refs.tabla.getItems();
                                this.$router.push('/presupuesto/' + this.presup);
                            }, e => {
                                this.msjShow({txt: 'Error de validación', tipo: 'error', errores: (e.errors) ? e.errors : ''});
                                this.loading = false;
                            })
                        } else {
                            this.presupuestoItemStore(this.d, r => {
                                this.msj = r;
                                this.limpiar();
                                this.loading = false;
                                this.$refs.tabla.getItems();
                            }, e => {
                                this.msjShow({txt: 'Error de validación', tipo: 'error', errores: (e.response.data.errors) ? e.response.data.errors : ''});
                                this.loading = false;
                            })
                        }
                    })
                    .catch(() => {
                        alert('error')
                    })
            },
            puertasGet() {
                this.puertasLoading = true;
                this.presupuestoItemLista({
                    presupuesto_id: this.d.presupuesto_id,
                    tipo_id: 'pue'
                }, r => {
                    this.puertas = r;
                    this.puertasLoading = false;
                }, err => {
                    console.log(err);
                    this.puertasLoading = false;
                })
            },
            equiposGet() {
                this.equiposLoading = true;
                this.presupuestoItemLista({
                    presupuesto_id: this.d.presupuesto_id,
                    tipo_id: 'equ'
                }, r => {
                    this.equipos = r;
                    this.equiposLoading = false;
                }, err => {
                    console.log(err)
                    this.equiposLoading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/item/cam.vue